import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es.json';
import en from './locales/en.json';

// Países de habla hispana
const SPANISH_COUNTRIES = [
  'ES', 'MX', 'AR', 'CO', 'PE', 'VE', 'CL', 'EC', 'GT', 'CU', 
  'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY', 'PR'
];

// Detectar idioma inicial
const detectLanguage = () => {
  // Primero revisar localStorage
  const saved = localStorage.getItem('i18nextLng');
  if (saved && ['es', 'en'].includes(saved)) {
    return saved;
  }
  
  // Usar idioma del navegador
  const browserLang = navigator.language?.split('-')[0];
  if (browserLang === 'es') {
    return 'es';
  }
  
  return 'en';
};

// Detectar por IP (async, actualiza después)
const detectByIP = async () => {
  try {
    const saved = localStorage.getItem('i18nextLng');
    if (saved) return; // Ya tiene preferencia guardada
    
    const response = await fetch('https://ipapi.co/json/');
    if (response.ok) {
      const data = await response.json();
      const countryCode = data.country_code;
      localStorage.setItem('detectedCountry', countryCode);
      
      const lang = SPANISH_COUNTRIES.includes(countryCode) ? 'es' : 'en';
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }
  } catch (error) {
    console.log('IP detection failed, using browser language');
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en }
    },
    lng: detectLanguage(),
    fallbackLng: 'en',
    supportedLngs: ['es', 'en'],
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

// Detectar por IP después de cargar
setTimeout(detectByIP, 1000);

export default i18n;

// Función helper para cambiar idioma manualmente
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('i18nextLng', lng);
  document.documentElement.lang = lng;
};

// Función para obtener el país detectado
export const getDetectedCountry = () => {
  return localStorage.getItem('detectedCountry') || 'Unknown';
};
